export default __webpack_public_path__ + "static/media/Au2Poster.fc0203bb.webp";